import { render, staticRenderFns } from "./CrudPage.vue?vue&type=template&id=4612645c"
import script from "./CrudPage.vue?vue&type=script&lang=js"
export * from "./CrudPage.vue?vue&type=script&lang=js"
import style0 from "./CrudPage.vue?vue&type=style&index=0&id=4612645c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports